import store from "../store";
import Vue from 'vue'

Vue.directive('hasButton', {
    inserted: function (el, binding) {
        if (!permissionJudge(binding.value)) {
            el.parentNode.removeChild(el);
        }

        function permissionJudge(value) {
            let list = store.getters.getAuthButtons;
            let passport = store.getters.passport
            if(list != null && list.indexOf(value) != -1 || (passport && passport.administrator)){
                return true;
            }
            return false;
        }
    }
});

Vue.directive('hasMenu', {
    inserted: function (el, binding) {
        if (!permissionJudge(binding.value)) {
            el.parentNode.removeChild(el);
        }

        function permissionJudge(value) {
            if (value === 'default') {
                return true
            }

            let list = store.getters.getAuthMenus;
            let passport = store.getters.passport
            if(list != null && list.indexOf(value) != -1 || (passport && passport.administrator)){
                return true;
            }
            return false;
        }
    }
});

Vue.prototype.hasButtons = function (value){
    let list = this.$store.getters.getAuthButtons;
    let flag = false;
    value.split(",").forEach(item=>{
        if(list != null && list.indexOf(item) != -1){
            flag=true;
        }
    })
    return flag;
}
